import { EFormSurveyFieldCriticalValue } from './e-form-survey-field-critical-value.model';

export class EFormSurveyField {
    ID: number;
    ForTemplate: boolean;
    TemplateID: number;
    InstanceID: number;
    QuestionText: string;
    ControlType: string;
    IsRequired: boolean;
    DefaultValue: string;
    CriticalQuestion: boolean;
    IsSelectionControl: boolean;
    AddedOn: Date;
    Addedby: number;
    LastUpOn: Date;
    LastUpBy: number;
    CriticalValues: EFormSurveyFieldCriticalValue[];
    EFormControlID: number;  // This will NOT be stored in the DB.  The only purpose is so we can create survey field records and them map those ID's back to the control to store the SurveyField ID in the JSON.  The control ID is not reliable long-term.
   }